import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ControlContainer, NgForm } from '@angular/forms';
import { Cargo } from 'src/app/core/cargo';
import { Funcionario } from 'src/app/core/funcionario';
import { ParecerEntrevistador } from 'src/app/core/parecer-entrevistador';
import { Unidade } from 'src/app/core/unidade';
import { EmpresaService } from 'src/app/services/empresa/empresa.service';
import { FuncionarioService } from 'src/app/services/funcionario/funcionario.service';
import { UnidadeService } from 'src/app/services/unidade/unidade.service';
import { Cbo } from '../../../../core/cbo';
import { CboService } from '../../../../services/cbo/cbo.service';
import { DataUtilService } from '../../../../services/commons/data-util.service';
import { ConclusaoParecer } from './../../../../core/conclusao-parecer';
import { Departamento } from './../../../../core/departamento';
import { Empresa } from './../../../../core/empresa';
import { TipoFuncionario } from './../../../../core/tipo-funcionario';
import { CargosService } from './../../../../services/cargos/cargos.service';
import { DepartamentoService } from './../../../../services/departamento/departamento.service';

@Component({
  selector: 'funcional',
  templateUrl: './funcional.component.html',
  styleUrls: ['./funcional.component.css'],
  viewProviders: [{ provide: ControlContainer, useExisting: NgForm }]
})
export class FuncionalComponent implements OnInit, OnChanges {
  descontaValeTransporte: boolean = false;
  descontaPecunia: boolean = false;
  cbos: Cbo[] = [];
  @Input() funcionario: Funcionario;

  tiposFuncionario: TipoFuncionario = new TipoFuncionario();

  listaParecer = [
    {id: ParecerEntrevistador.TOTALMENTO_ADEQUADO_PERFIL, descricao:'TOTALMENTE ADEQUADO AO PERFIL'},
    {id: ParecerEntrevistador.ADEQUADO_PERFIL, descricao:'ADEQUADO AO PERFIL'},
    {id: ParecerEntrevistador.NAO_ADEQUADO_PERFIL, descricao:' NÃO ADEQUADO AO PERFIL'},
    {id: ParecerEntrevistador.INDICADO_CONSULTA_FUTURA, descricao:'INDICADO PARA CONSULTA FUTURA'}
  ]

  conclusaoDoParecer = [
    {id: ConclusaoParecer.CONTINUAR, descricao: 'DAR CONTINUIDADE AO PROCESSO SELETIVO'},
    {id: ConclusaoParecer.NAO_CONTINUAR, descricao: 'NÃO DAR CONTINUIDADE AO PROCESSO SELETIVO'},
  ]

  sim_nao: any[] = [
    {tipo: 'Sim', flag: 'S'},
    {tipo: 'Não', flag: 'N'}
  ];

  funcionarios: Funcionario[];
  unidades: Unidade[];
  cargos: Cargo[];
  empresas: Empresa[];
  departamentos: Departamento[];

  constructor(
    private funcionarioService: FuncionarioService,
    private unidadeService: UnidadeService,
    private cargosService: CargosService,
    private empresaService: EmpresaService,
    private departamentoService: DepartamentoService, 
    private cboService: CboService,
    private dataUtilService: DataUtilService
    ) { }

  ngOnChanges(changes: SimpleChanges) {
    if (changes['funcionario'] && this.funcionario) {
      this.funcionario.empresaFuncionario ??= new Empresa();
      this.funcionario.cargo ??= new Cargo();
      this.funcionario.cargo.cbo ??= new Cbo();
      this.funcionario.unidade ??= new Unidade();
      this.funcionario.funcionarioEntrevistador ??= new Funcionario();
      this.funcionario.departamento ??= new Departamento();

      this.descontaValeTransporte = this.funcionario.descontaValeTransporte && String(this.funcionario.descontaValeTransporte) === 'S';
      this.descontaPecunia = this.funcionario.descontaPecunia && String(this.funcionario.descontaPecunia) === 'S';
    }
  }

  ngOnInit() {
    this.funcionario.empresaFuncionario = new Empresa();
    this.funcionario.cargo = new Cargo();
    this.funcionario.cargo.cbo = new Cbo();
    this.funcionario.cargo.cbo.id = null;
    this.funcionario.unidade = new Unidade();
    this.funcionario.funcionarioEntrevistador = new Funcionario();
    this.funcionario.departamento = new Departamento();


    this.funcionarioService.getAll().subscribe((funcionarios: Funcionario[])=> {
      this.funcionarios = funcionarios;
    });

    this.unidadeService.getAllByInstituicaoDaUnidadeLogada().subscribe((unidades: Unidade[])=> {
      this.unidades = unidades;
    });

    this.cargosService.getAll().subscribe((cargos: Cargo[])=> {
      this.cargos = cargos ? cargos.sort((a,b) => {
            if (a.nome > b.nome) {return 1;}
            if (a.nome < b.nome) {return -1;}
            return 0;
        }) : [];
    });

    this.empresaService.getAll().subscribe((empresas: Empresa[])=> {
      this.empresas = empresas;
    });

    this.departamentoService.getAll().subscribe((departamentos: Departamento[]) => {
      this.departamentos = departamentos;
    });

    this.cboService.getAll().subscribe((cbos: Cbo[]) => {
      this.cbos = cbos;
    });
  }

  mostrarCamposEntrevista(){
    const tipoFuncionario = this.tiposFuncionario.getTipo('D');
    return this.funcionario.tipoFuncionario === tipoFuncionario.tipo;
  }

  zerarCamposEntrevista(){
    if(!this.mostrarCamposEntrevista()){
      this.funcionario.funcionarioEntrevistador = new Funcionario();
      this.funcionario.dtHrEntrevista = null;
      this.funcionario.horaEntrevista = null;
      this.funcionario.salarioPretendido = null;
      this.funcionario.parecerEntrevistador = null;
      this.funcionario.conclusaoParecer = null;
      this.funcionario.descricaoParecerEntrevistador = null;
    }
  }

  atualizarDescontaValeTransporte(): void {
    this.funcionario.descontaValeTransporte = this.descontaValeTransporte;
  }

  atualizarDescontaPecunia(): void {
    this.funcionario.descontaPecunia = this.descontaPecunia;
  }


  onMascaraDataInput(event) {
    return this.dataUtilService.onMascaraDataInput(event);
  }

  onCargoChange(cargoId: number): void {
    const cargoSelecionado = this.cargos.find(c => c.id === cargoId);

    if (cargoSelecionado && cargoSelecionado.cbo) {
      this.funcionario.cargo.cbo = { ...cargoSelecionado.cbo };
    } else {
      this.funcionario.cargo.cbo = null;
    }
  }

}
